module.exports = __webpack_public_path__ + "static/media/Discover.8dea11da.svg";